import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { SERVER_HOST } from './constants';
import { Notice } from 'view-design';
const option = {
  baseURL: SERVER_HOST, // url = base url
  withCredentials: true, // send cookies when cross-domain requests
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json; charset=utf-8' },
};
/**
 * 检查是否为函数，如果是函数执行并返回值，如果不是直接返回
 * @param fun
 * @param args
 * @returns {*}
 */
const chekcFunction = (fun, args) => {
  return typeof fun === 'function' ? fun(args) : args;
};
/**
 * 接口请求成功后，拦截返回值
 * @param response
 * @returns {Promise<never>}
 */

interface Response {
  data: object;
  config: object;
}

interface ResData {
  code: string;
  result: object;
}

const responseSuccess = (response: Response) => {
  const { data, config } = response;
  const { code, result } = data as ResData;
  if ((code as any) === '200') {
    if (result) {
      return result;
    }
    return response
  } else if ((code as any) === '500') {
    responseError(data);
  } else if (response && (response as any).status && (response as any).status == '200') {
    return data
  }
};
const sResponseSuccess = (response: Response) => {
  const { data, config } = response;
  return data;
};
/**
 * 接口请求失败或者出现未知异常，给出错误提示信息
 * @param error
 * @returns {Promise<never>}
 */

interface Error {
  message?: string;
}
export const responseError = (error: Error) => {
  let message = error.message
  if (!message && typeof (error as any).result == 'string') {
    message = (error as any).result
  }
  (Notice as any).error({
    title: '提示',
    desc: message || '未知错误！',
  });
  return Promise.reject(error);
};
// http 直接返回result
export const http = axios.create(option);
// https 所有数据全部返回 用于自行判断code
export const https = axios.create(option);
// http response 拦截器 状态码为200时 直接返回result
http.interceptors.response.use(
  (response) => {
    response = chekcFunction(responseSuccess, response);
    return response;
  },
  (error) => {
    error = chekcFunction(responseError, error);
    return error;
  },
);
// https response 拦截器
https.interceptors.response.use(
  (response) => {
    response = chekcFunction(sResponseSuccess, response);
    return response;
  },
  (error) => {
    error = chekcFunction(responseError, error);
    return error;
  },
);
Vue.use(VueAxios, axios);
